import React from "react";
import "./Teamhero.css";

export default function Teamhero({
  bgImage = "/image2.jpg",
  title = "About Us",
  breadcrumbLeft = "Home",
  breadcrumbRight = "About Us",
}) {
  return (
    <section
      className="team-hero"
      style={{ backgroundImage: `url(${bgImage})` }}
      aria-label="Team hero banner"
    >
      {/* Dark overlay with new colors */}
      <div className="team-hero__overlay" aria-hidden="true" />

      <div className="team-hero__inner">
        <h1 className="team-hero__title">{title}</h1>

        <div className="team-hero__crumbs" aria-label="Breadcrumb">
          <span className="team-hero__crumb">{breadcrumbLeft}</span>
          <span className="team-hero__sep" aria-hidden="true">
            /
          </span>
          <span className="team-hero__crumb team-hero__crumb--active">
            {breadcrumbRight}
          </span>
        </div>
      </div>
    </section>
  );
}